import { z } from 'zod';
/**
 * Setores de atendimento (Financeiro, Suporte, Comercial…): horário, limites e SLA.
 * Os horários ficam no fuso America/Sao_Paulo (FUSO_HORARIO).
 */
export const DIAS_SEMANA = ['seg', 'ter', 'qua', 'qui', 'sex', 'sab', 'dom'];
export const ROTULO_DIA = {
    seg: 'Segunda',
    ter: 'Terça',
    qua: 'Quarta',
    qui: 'Quinta',
    sex: 'Sexta',
    sab: 'Sábado',
    dom: 'Domingo',
};
const horaSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Use o formato HH:MM');
/** Uma faixa "08:00"–"18:00". Um dia pode ter várias (ex.: manhã e tarde com intervalo). */
export const faixaHorarioSchema = z
    .tuple([horaSchema, horaSchema])
    .refine(([inicio, fim]) => inicio < fim, 'O horário final precisa ser depois do inicial');
export const horarioAtendimentoSchema = z
    .object(Object.fromEntries(DIAS_SEMANA.map((d) => [d, z.array(faixaHorarioSchema).default([])])))
    .superRefine((horario, ctx) => {
    for (const dia of DIAS_SEMANA) {
        const faixas = [...(horario[dia] ?? [])].sort((a, b) => a[0].localeCompare(b[0]));
        for (let i = 1; i < faixas.length; i++) {
            if (faixas[i][0] < faixas[i - 1][1]) {
                ctx.addIssue({
                    code: 'custom',
                    message: `${ROTULO_DIA[dia]}: há faixas sobrepostas`,
                    path: [dia],
                });
                break;
            }
        }
    }
});
export const HORARIO_COMERCIAL = {
    seg: [['08:00', '18:00']],
    ter: [['08:00', '18:00']],
    qua: [['08:00', '18:00']],
    qui: [['08:00', '18:00']],
    sex: [['08:00', '18:00']],
    sab: [['08:00', '12:00']],
    dom: [],
};
export const setorFormSchema = z.object({
    nome: z.string().trim().min(2, 'Informe o nome do setor').max(60),
    descricao: z.string().trim().max(200).optional().or(z.literal('')),
    ativo: z.boolean().default(true),
    ordem: z.coerce.number().int().min(0).max(999).default(0),
    horarioAtendimento: horarioAtendimentoSchema,
    mensagemForaHorario: z.string().trim().max(500).optional().or(z.literal('')),
    limitePadrao: z.coerce.number().int().min(1).max(50).default(5),
    /** Fila cai sozinha no atendente livre; desligado, a equipe puxa quando quiser. */
    distribuicaoAutomatica: z.boolean().default(true),
    /**
     * Só técnico de liberação logado entra nesta fila. Quem digitar a palavra-chave sem ter
     * entrado com a conta recebe o aviso e continua na triagem.
     */
    exigeTecnico: z.boolean().default(false),
    /**
     * O setor também atende o técnico, sem ser exclusivo dele. É o que o faz aparecer na
     * lista do app do técnico ao lado da Liberação — o cliente continua entrando normalmente
     * pela triagem.
     */
    aceitaTecnico: z.boolean().default(false),
    /**
     * Atende 24 horas e recolhe o que chega fora do horário dos outros setores. Um só no
     * sistema: quem escolher um setor fechado vai parar aqui, em vez de ouvir que ninguém
     * responde hoje.
     */
    atende24h: z.boolean().default(false),
    /** Segundos para a primeira resposta do atendente; vazio = sem SLA. */
    slaPrimeiraRespostaSeg: z.coerce.number().int().min(30).max(86_400).nullable().default(null),
    /** Segundos sem mensagem do cliente antes de encerrar por inatividade. */
    slaInatividadeSeg: z.coerce.number().int().min(60).max(86_400).nullable().default(null),
});
//# sourceMappingURL=setores.js.map